const options = {
  5: "bg-violet-500/5",
  10: "bg-violet-500/10",
  25: "bg-violet-500/25",
  50: "bg-violet-500/50",
  75: "bg-violet-500/75",
  90: "bg-violet-500/90",
  100: "bg-violet-500",
};

const from = {
  5: "from-violet-500/5",
  10: "from-violet-500/10",
  25: "from-violet-500/25",
  50: "from-violet-500/50",
  75: "from-violet-500/75",
  90: "from-violet-500/90",
  100: "from-violet-500",
};

export default function getBackgroundViolet500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
